export default {
  // Nav
  'nav.home': 'Home',
  'nav.categories': 'Categories',
  'nav.guides': 'Guides',
  'nav.safety': 'Safety',
  'nav.browse': 'Browse the Store',
  'nav.shoppingGuide': 'Shopping Guide',

  // Hero
  'hero.badge': 'Independent Resource · Regularly Updated',
  'hero.title': 'USFans Spreadsheet — Find, Organize & Explore USFans Resources',
  'hero.subtitle': 'Discover creators, categories, guides and safety tips from one organized hub. Browse the complete USFans spreadsheet and shop the latest gear.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Buy It Now',
  'hero.trust': 'Organized Information · Verified Links · Simple Navigation',

  // Categories
  'categories.title': 'Browse USFans Categories',
  'categories.subtitle': 'Jump straight to the category you are looking for in the USFans spreadsheet.',
  'categories.dropdownLabel': 'Quick Category Search',
  'categories.dropdownPlaceholder': 'Select a category',

  // Category names
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies / Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants / Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear / Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',

  // What is
  'whatis.title': 'What Is the USFans Spreadsheet?',
  'whatis.p1': 'The USFans Spreadsheet is an organized resource designed to help you discover and research USFans-related information in one place.',
  'whatis.p2': 'Instead of searching through scattered pages, you can explore structured categories, creator information, guides and safety tips from a single convenient hub.',
  'whatis.p3': 'Explore, compare and verify — everything you need is collected and sorted for faster browsing.',

  // Value proposition
  'value.title': 'Everything You Need to Explore USFans in One Place',
  'value.subtitle': 'A single organized hub with the tools and topics people search for most.',
  'value.item1': 'USFans Spreadsheet',
  'value.item2': 'Creator Directory',
  'value.item3': 'Search & Discovery Guides',
  'value.item4': 'Reviews & Comparisons',
  'value.item5': 'Shipping Information',
  'value.item6': 'Coupon Resources',
  'value.item7': 'Warehouse Guides',
  'value.item8': 'Safety & Security',

  // Popular searches
  'popular.title': 'Popular USFans Searches',
  'popular.subtitle': 'Quickly explore the topics people search for most.',
  'popular.review.title': 'USFans Review',
  'popular.review.desc': 'Learn about features, user experience, advantages and important considerations.',
  'popular.shipping.title': 'USFans Shipping Cost',
  'popular.shipping.desc': 'Understand shipping-related information, pricing factors and what affects total costs.',
  'popular.coupon.title': 'USFans Coupon',
  'popular.coupon.desc': 'Find information about available promotions, offers and coupon-related resources.',
  'popular.discount.title': 'USFans Discount Code',
  'popular.discount.desc': 'Explore current discount information and learn how to verify promotional offers.',
  'popular.warehouse.title': 'USFans Warehouse',
  'popular.warehouse.desc': 'Learn how warehouse-related services and processes work.',
  'popular.legit.title': 'USFans Legit',
  'popular.legit.desc': 'Understand how to evaluate legitimacy, trust signals, website security and potential risks.',

  // Comparison
  'comparison.title': 'USFans Resources Compared',
  'comparison.subtitle': 'A quick overview of how each resource helps you explore USFans.',
  'comparison.col1': 'Resource',
  'comparison.col2': 'Best For',
  'comparison.col3': 'Organization',
  'comparison.col4': 'Updates',
  'comparison.col5': 'Beginner Friendly',
  'comparison.r1': 'USFans Spreadsheet',
  'comparison.r1best': 'Organized research',
  'comparison.r2': 'Creator Directory',
  'comparison.r2best': 'Creator discovery',
  'comparison.r3': 'Search Guide',
  'comparison.r3best': 'Finding information',
  'comparison.r4': 'Review Guide',
  'comparison.r4best': 'Evaluating options',

  // Safety
  'safety.title': 'Stay Safe While Exploring USFans Resources',
  'safety.p': 'Always verify links before clicking, avoid suspicious login pages, never share your passwords, protect your personal information and be cautious with unknown downloads or payment requests.',
  'safety.link': 'Read Our Safety & Security Guide',

  // Articles
  'articles.title': 'USFans Guides & Articles',
  'articles.subtitle': 'Original, in-depth resources to help you get the most out of the USFans spreadsheet.',
  'articles.cardTitle': 'USFans Spreadsheet: Complete Guide',
  'articles.cardDesc': 'Everything you need to know about finding, organizing and exploring USFans resources — categories, tips and safety.',
  'articles.readMore': 'Read the Guide',

  // Final CTA
  'final.title': 'Ready to Explore the USFans Spreadsheet?',
  'final.subtitle': 'Find organized information, useful guides and frequently searched USFans topics from one central hub.',
  'final.cta': 'Explore USFans Spreadsheet',

  // Footer
  'footer.tagline': 'An independent informational resource for the USFans spreadsheet and everything around it.',
  'footer.disclaimer': 'USFansLink.cfd is an independent informational resource and is not affiliated with or endorsed by USFans unless explicitly stated.',
  'footer.quickLinks': 'Quick Links',
  'footer.resources': 'Resources',
  'footer.copyright': 'All rights reserved.',
};